import { render } from "./LoginWhatsApp.vue?vue&type=template&id=3ab46ae8&scoped=true"
import script from "./LoginWhatsApp.vue?vue&type=script&lang=js"
export * from "./LoginWhatsApp.vue?vue&type=script&lang=js"

import "./LoginWhatsApp.vue?vue&type=style&index=0&id=3ab46ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab46ae8"]])

export default __exports__